import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { API_BASE_URL } from "../api_config";
import UserContext from "../../Components/Authcontext";
import { fetchEducationData, fetchOccupations } from "../apis";
import Load from "../Loading/Load";
import "./modern-forms.css";
import axios from "axios";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "auto",
    minHeight: "40px",
    borderRadius: "10px",
    boxShadow: "none",
    borderColor: "#e1e1e1",
    backgroundColor: "#f9f9f9",
    '&:hover': {
      borderColor: "#e84393"
    }
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: "9999",
    borderRadius: "8px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "200px",
    overflowY: "scroll",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#f0f0f0",
    borderRadius: "6px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#333",
    ':hover': {
      backgroundColor: "#e84393",
      color: "white",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#e84393" : state.isFocused ? "#f9e7f4" : "white",
    color: state.isSelected ? "white" : "#333",
    ':active': {
      backgroundColor: "#e84393",
    }
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333",
  }),
};

function ModernPersonalDetails() {
  const { user, token } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [education, setEducation] = useState([]);
  const [emptype, setEmptype] = useState("");
  const [occupation, setOccupation] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [income, setIncome] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [bodyType, setBodyType] = useState("");
  const [complexion, setComplexion] = useState("");
  const [physicalStatus, setPhysicalStatus] = useState("");
  const [educationOptions, setEducationOptions] = useState([]);
  const [occupationOptions, setOccupationOptions] = useState([]);

  const navigate = useNavigate();

  // Define the form steps
  const totalSteps = 8;
  const currentStep = 3;

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
      const educationData = await fetchEducationData();
      const occupationData = await fetchOccupations();

      setEducationOptions(educationData);

      // Transform occupation data to the correct format
      const formattedOccupationData = occupationData.map(occ => ({
        value: occ.occupation || occ.id,
        label: occ.occupation || occ.name
      }));
      
      setOccupationOptions(formattedOccupationData);
      
      console.log("Education options:", educationData);
      console.log("Occupation options:", formattedOccupationData);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleEducationChange = (selectedOptions) => {
    setEducation(selectedOptions);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      // Format education data the same way as the original form
      const selectedEducations = education.map((edu) => edu.value);

      const response = await axios.post(
        `${API_BASE_URL}/api/PersonalDetails`,
        {
          user,
          education: selectedEducations,
          emptype,
          occupation,
          income,
          companyName,
          height,
          weight,
          bodytype: bodyType,     // Match the original field name
          complexion,
          physical: physicalStatus, // Match the original field name
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      console.log("Personal Details API Response:", response.data);

      if (response.data.auth) {
        setLoading(false);
        navigate("/modern-image-upload", { replace: true });
        setEducation([]);
        setEmptype("");
        setOccupation("");
        setCompanyName("");
        setIncome("");
        setHeight("");
        setWeight("");
        setBodyType("");
        setComplexion("");
        setPhysicalStatus("");
      } else {
        setLoading(false);
        alert("Error: " + (response.data.message || "Failed to save personal details"));
      }
    } catch (error) {
      console.error("API Error:", error);
      setLoading(false);
      alert("Error: " + (error.response?.data?.message || error.message || "Failed to save personal details"));
    }
  };

  // Calculate progress percentage
  const progressPercentage = (currentStep / totalSteps) * 100;

  return loading ? (
    <Load />
  ) : (
    <div className="profile-form-container">
      <div className="decoration decoration-1"></div>
      <div className="decoration decoration-2"></div>
      <div className="decoration decoration-3"></div>
      <div className="decoration decoration-4"></div>
      <div className="profile-form-card">
        {/* Form Header with Progress Bar */}
        <div className="profile-form-header">
          <div className="progress-container">
            <div className="progress-steps">
              {Array.from({ length: totalSteps }, (_, i) => (
                <div key={i} className="progress-step">
                  <div
                    className={`step-number ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 < currentStep ? "✓" : i + 1}
                  </div>
                  <div
                    className={`step-label ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 === 1 && "Basic Info"}
                    {i + 1 === 2 && "Contact"}
                    {i + 1 === 3 && "Personal"}
                    {i + 1 === 4 && "Photos"}
                    {i + 1 === 5 && "Family"}
                    {i + 1 === 6 && "Lifestyle"}
                    {i + 1 === 7 && "Religious"}
                    {i + 1 === 8 && "Preferences"}
                  </div>
                </div>
              ))}
              <div className="progress-line">
                <div
                  className="progress-line-fill"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>
          </div>
          <h2 className="profile-form-title">Personal Details</h2>
          <p className="profile-form-subtitle">Tell us about yourself</p>
          <p className="required-fields-note">All fields are mandatory</p>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit}>
          <div className="profile-form-body">
            <div className="form-group">
              <label className="form-label">Education</label>
              <Select
                isMulti
                options={educationOptions}
                value={education}
                onChange={handleEducationChange}
                styles={customStyles}
                placeholder="Select your education"
                className="react-select-container"
                classNamePrefix="react-select"
                required
              />
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Employment Type</label>
                  <select
                    className="form-control"
                    value={emptype}
                    onChange={(e) => setEmptype(e.target.value)}
                    required
                  >
                    <option value="">Select employment type</option>
                    <option value="Government">Government</option>
                    <option value="Private">Private</option>
                    <option value="Business">Business</option>
                    <option value="Self Employed">Self Employed</option>
                    <option value="Not Working">Not Working</option>
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Occupation</label>
                  <select
                    className="form-control"
                    value={occupation}
                    onChange={(e) => setOccupation(e.target.value)}
                    required
                  >
                    <option value="">Select occupation</option>
                    {occupationOptions.map((option) => (
                      <option key={option.value} value={option.label}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Company Name</label>
                  <input
                    className="form-control"
                    type="text"
                    value={companyName}
                    placeholder="Enter company name"
                    onChange={(e) => setCompanyName(e.target.value)}
                    required
                  />
                </div>
              </div>
              
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Monthly Income</label>
                  <input
                    className="form-control"
                    type="text"
                    value={income}
                    placeholder="Enter monthly income"
                    onChange={(e) => setIncome(e.target.value)}
                    required
                  />
                </div>
              </div>
              
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Height</label>
                  <select
                    className="form-control"
                    value={height}
                    onChange={(e) => setHeight(e.target.value)}
                    required
                  >
                    <option value="">Select height</option>
                    <option value="4ft 5in - 134cm">4ft 5in - 134cm</option>
                    <option value="4ft 6in - 137cm">4ft 6in - 137cm</option>
                    <option value="4ft 7in - 140cm">4ft 7in - 140cm</option>
                    <option value="4ft 8in - 142cm">4ft 8in - 142cm</option>
                    <option value="4ft 9in - 145cm">4ft 9in - 145cm</option>
                    <option value="4ft 10in - 147cm">4ft 10in - 147cm</option>
                    <option value="4ft 11in - 150cm">4ft 11in - 150cm</option>
                    <option value="5ft 0in - 152cm">5ft 0in - 152cm</option>
                    <option value="5ft 1in - 155cm">5ft 1in - 155cm</option>
                    <option value="5ft 2in - 157cm">5ft 2in - 157cm</option>
                    <option value="5ft 3in - 160cm">5ft 3in - 160cm</option>
                    <option value="5ft 4in - 163cm">5ft 4in - 163cm</option>
                    <option value="5ft 5in - 165cm">5ft 5in - 165cm</option>
                    <option value="5ft 6in - 168cm">5ft 6in - 168cm</option>
                    <option value="5ft 7in - 170cm">5ft 7in - 170cm</option>
                    <option value="5ft 8in - 173cm">5ft 8in - 173cm</option>
                    <option value="5ft 9in - 175cm">5ft 9in - 175cm</option>
                    <option value="5ft 10in - 178cm">5ft 10in - 178cm</option>
                    <option value="5ft 11in - 180cm">5ft 11in - 180cm</option>
                    <option value="6ft 0in - 183cm">6ft 0in - 183cm</option>
                    <option value="6ft 1in - 185cm">6ft 1in - 185cm</option>
                    <option value="6ft 2in - 188cm">6ft 2in - 188cm</option>
                    <option value="6ft 3in - 190cm">6ft 3in - 190cm</option>
                    <option value="6ft 4in - 193cm">6ft 4in - 193cm</option>
                    <option value="6ft 5in - 196cm">6ft 5in - 196cm</option>
                    <option value="6ft 6in - 198cm">6ft 6in - 198cm</option>
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Weight</label>
                  <input
                    className="form-control"
                    type="text"
                    value={weight}
                    placeholder="Enter weight in kg"
                    onChange={(e) => setWeight(e.target.value.replace(/\D/g, ""))}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Body Type</label>
                  <select
                    className="form-control"
                    value={bodyType}
                    onChange={(e) => setBodyType(e.target.value)}
                    required
                  >
                    <option value="">Select body type</option>
                    <option value="Slim">Slim</option>
                    <option value="Athletic">Athletic</option>
                    <option value="Average">Average</option>
                    <option value="Heavy">Heavy</option>
                  </select>
                </div>
              </div>
              <div className="form-col">
                {/* <div className="form-group">
                  <label className="form-label">Skin Color</label>
                  <select
                    className="form-control"
                    value={complexion}
                    onChange={(e) => setComplexion(e.target.value)}
                    required
                  >
                    <option value="">Select complexion</option>
                    <option value="Very Fair">Very Fair</option>
                    <option value="Fair">Fair</option>
                    <option value="Wheatish">Wheatish</option>
                    <option value="Wheatish Brown">Wheatish Brown</option>
                    <option value="Dark">Dark</option>
                  </select>
                </div> */}
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Physical Status</label>
              <select
                className="form-control"
                value={physicalStatus}
                onChange={(e) => setPhysicalStatus(e.target.value)}
                required
              >
                <option value="">Select physical status</option>
                <option value="Normal">Normal</option>
                <option value="Physically Challenged">Physically Challenged</option>
              </select>
            </div>
          </div>

          {/* Form Footer with Buttons */}
          <div className="profile-form-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={() => navigate("/modern-contact-info")}
            >
              Back
            </button>
            <button type="submit" className="btn btn-primary">
              Save & Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModernPersonalDetails;
